<div class="row mb-3">
    <div class="col-12 d-flex justify-content-between align-items-center">
        <h2 class="fs-4 fw-bold mb-0">Editar Acerca de</h2>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Cerrar"></button>
    </div>
</div>
<div class="info-container">
    <div class="content-item">
        <textarea class="form-control no-resize" aria-label="Biografía" id="tx_biography" [(ngModel)]="tx_biography" maxlength="1000" rows="6"></textarea>
        <div class="text-start mt-1 text-muted small">{{ tx_biography.length || 0 }} / 1000 caracteres</div>
        <div class="row">
            <div class="col m-3 d-flex justify-content-center">
                <button class="btn btn-primary" aria-label="Guardar biografía" (click)="saveBiography()">Guardar</button>
            </div>
        </div>
    </div>
</div>
